import { render, staticRenderFns } from "./Index1.vue?vue&type=template&id=ddc438da&scoped=true"
import script from "./Index1.vue?vue&type=script&lang=js"
export * from "./Index1.vue?vue&type=script&lang=js"
import style0 from "./Index1.vue?vue&type=style&index=0&id=ddc438da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc438da",
  null
  
)

export default component.exports